<template>
  <div class="open-invoice">
    <div class="open-invoice-flex">
      <div class="invoice-details">
        <div class="invoice-details-title"><span class="red">*</span>发票详情(必填)</div>
        <van-notice-bar v-if="form.invoiceTitleType == 2"
          left-icon="volume-o"
          text="如需报销，建议选择企业单位" mode="closeable"
        />
        <div class="invoice-info">
          <div class="invoice-row">
            <div class="invoice-row-name">发票类型</div>
            <div class="invoice-row-flex">
              
              <template v-for="(item,index) in invoiceTypeList">
                <div class="radio-label" :key="index" @click="form.invoiceType = item.itemKey">
                  <img src="../../assets/img/radio-y.png" alt="" v-if="form.invoiceType == item.itemKey">
                  <img src="../../assets/img/radio.png" alt="" v-else>
                  {{item.itemValue}}
                </div>
              </template>
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">抬头类型</div>
            <div class="invoice-row-flex">
              <div class="radio-label" v-for="(item,index) in invoiceTitleTypeList" :key="index" @click="invoiceTitleTypeClick(item)  ">
                <img src="../../assets/img/radio-y.png" alt="" v-if="form.invoiceTitleType == item.itemKey">
                <img src="../../assets/img/radio.png" alt="" v-else>
                {{item.itemValue}}
              </div>
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">发票抬头</div>
            <div class="invoice-row-flex">
              
              {{form.invoiceTitle == '' ? '请选择发票抬头': form.invoiceTitle}}
            </div>
            <div @click="openPopup">
              <img src="../../assets/img/more-grey.png" alt="" class="select-img">
            </div>
          </div>
          <div class="invoice-row" v-if="form.invoiceTitleType == '1'">
            <div class="invoice-row-name">税号</div>
            <div class="invoice-row-flex">
              
              {{form.taxId == '' ? '请选择发票抬头': form.taxId}}
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">服务费</div>
            <div class="invoice-row-flex">
              <span class="main-color">{{amountInfo.serviceAmount || '--'}}</span>元
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">电费</div>
            <div class="invoice-row-flex">
              <span class="main-color">{{amountInfo.chargeAmount || '--'}}</span>元
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">发票金额</div>
            <div class="invoice-row-flex">
              <span class="main-color">{{form.invoiceAccount}}</span>元
            </div>
          </div>
        </div> 
      </div>
      <div class="invoice-details">
        <div class="invoice-details-title"><span class="red">*</span>接收信息(必填)</div>
        <div class="invoice-info">
          <div class="invoice-row">
            <div class="invoice-row-name">电子邮箱</div>
            <div class="invoice-row-flex">
              <input type="text" placeholder="用于向您发送电子发票" v-model="form.sendEmail">
            </div>
          </div>
          <div class="invoice-row">
            <div class="invoice-row-name">手机号</div>
            <div class="invoice-row-flex">
              <input type="text" placeholder="请填写您的手机号" v-model="form.phoneNo">
            </div>
          </div>
          <template v-if="form.invoiceType == '1'">
            <div class="invoice-row">
              <div class="invoice-row-name">收件人</div>
              <div class="invoice-row-flex">
                <input type="text" placeholder="请填写收件人" v-model="form.addressee">
              </div>
            </div>
            <div class="invoice-row">
              <div class="invoice-row-name">是否邮寄</div>
              <div class="invoice-row-flex">
                <div class="radio-label" v-for="(item,index) in hasMailList" :key="index" @click="form.hasMail = item.itemKey">
                  <img src="../../assets/img/radio-y.png" alt="" v-if="form.hasMail == item.itemKey">
                  <img src="../../assets/img/radio.png" alt="" v-else>
                  {{item.itemValue}}
                </div>
              </div>
            </div>
            <div class="invoice-row" v-if="form.hasMail == '1'">
              <div class="invoice-row-name">收件地址</div>
              <div class="invoice-row-flex">
                <input type="text" placeholder="请填写收件地址，用于邮寄发票" v-model="form.mailingAddress">
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="btn-box">
      <pi-button  :type="loading ? 'loading':'primary'" block @click="subAddInvoice">提交开票</pi-button>
    </div>
    <pi-popup-content ref="popupContent" type="bottom">
      <div class="popup-box">
        
        <div class="popup-title">
          <!-- <div class="colse-box">
            <img src="../../assets/img/del-icon.png" alt="">
          </div> -->
          {{invoiceTitleTypeObj[form.invoiceTitleType]}}抬头
        </div>
        <ul class="invoice-type-list">
          <template v-for="(item,index) in invoiceTempList">
            <li class="invoice-type-item" :key="index" v-if="item.invoiceTitleType == form.invoiceTitleType">
              
              <div class="invoice-select-icon" @click="selectClick(item)">
                <img src="../../assets/img/radio-yes.png" v-if="item.invoiceTitlePkId == invoiceTitlePkId" alt="">
                <img src="../../assets/img/radio.png" v-else alt="">
              </div>
              <div class="invoice-type-flex" @click="selectClick(item)">{{item.invoiceTitle}} <van-tag type="warning" v-if="item.hasDefault">默认</van-tag></div>
              <div class="right-icon-box" @click="goDetails(item)">
                <img class="right-icon" src="../../assets/img/icon-right.png" alt="">
              </div>
            </li>
          </template>
          <li v-if="invoiceTempList.length == 0" class="no-list-data">暂无发票抬头</li>
        </ul>
        <div class="popup-btn-box">
          <pi-button type="primary" block @click="addInvoice">添加常用的发票抬头</pi-button>
          <pi-button :type="invoiceTitlePkId == '' ? 'default' : 'danger'" block @click="delInvoice" style="margin-top:0.12rem">删除</pi-button>
        </div>
      </div>
    </pi-popup-content>
  </div>
</template>
<script>
import {getDictInfoList,getInvoiceTitleList, addInvoice,getChargeOrderAmountInfo,deleteInvoiceTitle,getOprFeatureConfig} from '../../common/api/index'
import popupContent from '@/components/pi-popup-content/pi-popup-content.vue'
import { Tag , NoticeBar} from 'vant';
import { mapState } from "vuex";
export default {
  name: 'pi-open-invoice',
  data(){
    return{
      invoiceTempList: [
      ],
      invoiceTitleTypeList : [],
      invoiceTitleTypeObj : {},
      invoiceTypeList : [],
      invoiceTypeObj : {},
      form: {
        "addressee": "",
        "hasMail": '1',
        "invoiceAccount": '',
        "invoiceTitle": "",
        "invoiceTitleType": '1',
        "invoiceTitlePkId": "",
        "invoiceType": '1',
        "mailingAddress": "",
        "orderNos": [],
        "phoneNo": "",
        "sendEmail": "",
        "taxId": "",
        "type": '1'
      },
      invoiceTitlePkId: '',
      hasMailList: [
        {itemValue: '否',itemKey: '0'},
        {itemValue: '是',itemKey: '1'},
      ],
      loading: false,
      amountInfo: {},
      oprCongifInfo: {}
    }
  },
  components: {
    [popupContent.name]: popupContent,
    [Tag.name]: Tag,
    [NoticeBar.name]: NoticeBar,
  },
  methods: {
    openPopup(){
      this.$refs.popupContent.open();
    },
    addInvoice(){
      this.$common.save('invoice-input',{
        form: this.form,
        invoiceTitlePkId: this.invoiceTitlePkId,
        invoiceTitleType: this.form.invoiceTitleType
      },1);
      this.$router.push('/open-invoice-add?invoiceTitleType=' + this.form.invoiceTitleType)
    },
    async delInvoiceSub(){
      let ret = await deleteInvoiceTitle({invoiceTitlePkId:this.invoiceTitlePkId});
      if (ret.status === this.$config.ajaxStatus) {
        this.$toast('删除成功');
        let index = -1;
        let arr = [];
        this.invoiceTempList.map((item,i)=>{
          if(item.invoiceTitleType == this.form.invoiceTitleType){
            if(item.invoiceTitlePkId == this.invoiceTitlePkId){
              index = i;
            }else{
              arr.push(item);
            }
          }
        })
        this.invoiceTempList.splice(index,1);
        if(arr[0]){
          this.invoiceTitlePkId = arr[0].invoiceTitlePkId;
          console.log(this.invoiceTitlePkId)
          this.invoiceTitleDetails();
        }else{
          this.invoiceTitlePkId = '';
          this.form.invoiceTitle = '';
          this.form.taxId = '';
        }
      }
    },
    delInvoice(){
      this.$dialog
        .confirm({
          message: "确定要删除该发票抬头吗",
          confirmButtonText: "确定",
          confirmButtonColor: "#14CC80",
          closeOnPopstate: true
        })
        .then(() => {
          this.delInvoiceSub();
        }).catch(() => {
          // on cancel
        });
      
    },
    goDetails(item){
      this.$common.save('invoice-input',{
        form: this.form,
        invoiceTitlePkId: this.invoiceTitlePkId
      },1);
      this.$router.push('/open-invoice-add?invoiceTitlePkId=' + item.invoiceTitlePkId+'&invoiceTitleType='+this.form.invoiceTitleType);
    },
    
    getInvoiceTitleList(){
      getInvoiceTitleList({}).then(ret=>{
        if (ret.status === this.$config.ajaxStatus) {
          this.invoiceTempList = ret.data || [];
          
          if(ret.data[0]){
            if(this.invoiceTitlePkId == ''){
              ret.data.map(item=>{
                if(item.invoiceTitleType == this.form.invoiceTitleType && this.invoiceTitlePkId ==''){
                  this.invoiceTitlePkId = item.invoiceTitlePkId;
                }
              })
              // this.invoiceTitlePkId = ret.data[0].invoiceTitlePkId;
            }
            this.invoiceTitleDetails()
          }
        }
      })
    },
    invoiceTitleDetails(){
      this.invoiceTempList.map(item=>{
        if(item.invoiceTitlePkId == this.invoiceTitlePkId){
          this.form.invoiceTitle = item.invoiceTitle;
          this.form.taxId = item.taxId;
          this.form.invoiceTitlePkId = item.invoiceTitlePkId;
        }
      })
      // invoiceTitleDetails({invoiceTitlePkId: this.invoiceTitlePkId}).then(ret=>{
      //   if (ret.status === this.$config.ajaxStatus) {
      //     let data = ret.data[0];
      //     this.form.invoiceTitle = data.invoiceTitle;
      //     this.form.taxId = data.taxId;
      //   }
      // })
    },
    subAddInvoice(){
      var email = /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/; // 邮箱
      if(this.form.invoiceTitle == ''){
        this.$toast('请选择发票抬头')
      }else if(this.form.sendEmail == ''){
        this.$toast('请填写电子邮箱')
      }else if(!email.test(this.form.sendEmail)){
        this.$toast('请输入正确的电子邮箱')
      }else if(this.form.addressee == '' && this.form.invoiceType == '1'){
        this.$toast('请填写收件人')
      }else if(this.form.phoneNo == ''){
        this.$toast('请填写手机号码')
      }else if (!/^[1][23456789][0-9]{9}$/.test(this.form.phoneNo)) {
        this.$toast("手机号格式不正确");
      }else if(this.form.hasMail == '1' && this.form.mailingAddress == '' && this.form.invoiceType == '1'){
        this.$toast('请填邮寄地址')
      }else{
        let json = JSON.parse(JSON.stringify(this.form));
        json.hasMail = json.hasMail == '1' ? true : false;
        this.loading = true;
        addInvoice(json).then(ret=>{
          if (ret.status === this.$config.ajaxStatus) {
            this.$toast('提交成功，系统处理中,请稍后查看');
            this.$common.goBack();
          }else{
            this.$toast(ret.msg);
          }
          this.loading = false;
        })
      }
    },
    selectClick(item){
      this.invoiceTitlePkId = item.invoiceTitlePkId
      this.invoiceTitleDetails(item.invoiceTitlePkId)
      this.$refs.popupContent.close();
    },
    invoiceTitleTypeClick(item){
      this.form.invoiceTitleType = item.itemKey;
      this.invoiceTitlePkId = '';
      this.form.invoiceTitle = '';
      this.form.taxId = '';
    },
    async getChargeOrderAmountInfo(){
      let ret = await getChargeOrderAmountInfo({
        orderNos: this.form.orderNos
      });
      if (ret.status === this.$config.ajaxStatus) {
        this.amountInfo = ret.data[0] || {};
        this.form.serviceAmount = this.amountInfo.serviceAmount;
        this.form.chargeAmount = this.amountInfo.chargeAmount;
      }
    },
    async getOprFeatureConfig() {
      let ret = await getOprFeatureConfig({}, { loading: false });
      if (ret.status === 0) {
        let data = ret.data[0] || {};
        this.oprCongifInfo = data.invoiceConfig || {}
        this.getDictInfoList();
      }
    },
    getDictInfoList(){
      getDictInfoList({
        typeIdList: '12414,12413',
      }, true).then((data) => {
        if (data.status === this.$config.ajaxStatus) {
          
          if(data.data.length > 0){
            let invoiceTitleTypeList = [];
            let invoiceTitleTypeObj = {};
            let invoiceTypeList = [];
            let invoiceTypeObj = {};
            data.data.map(item=>{
              if(item.typePkId == 12414){
                invoiceTitleTypeObj[item.itemKey] = item.itemValue;
                invoiceTitleTypeList.push(item);
              }
              if(item.typePkId == 12413){
                if(item.itemKey == '2' && this.oprCongifInfo.openElectron || item.itemKey == '1' && this.oprCongifInfo.openPaper){
                  invoiceTypeList.push(item);
                }
              }
            })
            if(invoiceTypeList.length > 0){
              this.form.invoiceType = invoiceTypeList[0].itemKey;
            }
            this.invoiceTitleTypeList = invoiceTitleTypeList;
            this.invoiceTitleTypeObj = invoiceTitleTypeObj;
            this.invoiceTypeList = invoiceTypeList;
            this.invoiceTypeObj = invoiceTypeObj;
          }
        }
      })
    },
  },
  computed: {
    ...mapState(["user"]),
  },
  mounted() {
    
    if(this.user.userObject){
      this.form.phoneNo = this.user.userObject.phoneNo || '';
    }
    let invoiceInput = this.$common.get('invoice-input',1);
    if(invoiceInput){
      this.form = Object.assign(this.form,invoiceInput.form);
      this.invoiceTitlePkId = invoiceInput.invoiceTitlePkId
      this.$common.remove('invoice-input',1);
    }
    
    let openInvoiceData = this.$common.get('openInvoiceData',1);
    if(openInvoiceData){
      this.form.invoiceAccount = openInvoiceData.money;
      this.form.orderNos = openInvoiceData.orderNo;
      this.form.type = openInvoiceData.type;
      this.getChargeOrderAmountInfo();
    }
    // let query = this.$route.query;
    // this.form.invoiceAccount = query.money;
    // this.form.orderNos = query.orderNo.split(',');
    // this.form.type = query.type;
    
    this.$common.bodyAddBg();
    this.getInvoiceTitleList();
    this.getOprFeatureConfig();
  },
  destroyed () {
    this.$common.removeBodyBg();
  },
}
</script>
<style lang="less">
@import url('./css/invoice');

</style>